module.exports = __webpack_public_path__ + "img/image.79d32a3e.png";